<template>
  <div>
    <assembleia-configuracao-edit @gravado="onGravar" />
    <hr>
    <assembleia-item-pauta-list
      v-if="assembleia.id"
      :assembleia="assembleia"
    />
  </div>
</template>

<script>
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import AssembleiaConfiguracaoEdit from './AssembleiaConfiguracaoEdit.vue'
import AssembleiaItemPautaList from './AssembleiaItemPautaList.vue'

export default {
  name: 'EditAssembleia',
  components: {
    'assembleia-item-pauta-list': AssembleiaItemPautaList,
    'assembleia-configuracao-edit': AssembleiaConfiguracaoEdit,
  },
  data() {
    return {
      wizard: true,
      assembleia: {
        id: 0,
        titulo: '',
      },
    }
  },
  created() {
    if (this.$route.params.id) {
      this.assembleia.id = this.$route.params.id
    }
  },
  methods: {
    onGravar(assembleia) {
      this.assembleia = this.$set(this, 'assembleia', assembleia)
    },
  },
}
</script>

<style lang="scss"></style>
